import { Fab as MuiFab, Zoom } from "@mui/material";
import { PropTypes } from "prop-types";
import styles from "./styles";

const Fab = ({ color, onClick, Icon, ...restProps }) => (
  <Zoom in>
    <MuiFab onClick={onClick} color={color} size="medium" {...restProps}>
      <Icon className={styles.icon} />
    </MuiFab>
  </Zoom>
);

Fab.defaultProps = {
  color: "primary",
  Icon: null,
};

Fab.propTypes = {
  color: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  Icon: PropTypes.object,
};

export default Fab;
